import * as Const from '../Constants';

export function mapTypeToIcon(type: string): string {
    switch (type) {
        case Const.OUTOTEC:
            return 'outotec-logo';
        case Const.TYPE_COUNTRY:
        case Const.TYPE_SITE:
            return 'site';

        case Const.TYPE_CUSTOMERS:
            return 'customer';

        case Const.TYPE_CAPEX:
        case Const.TYPE_PRODUCT_GROUP:
        case Const.TYPE_PRODUCT_FAMILY:
        case Const.TYPE_PRODUCT_SERIES:
        case Const.TYPE_SELLABLE_PRODUCT_MODEL:
        case Const.TYPE_EQUIPMENT_PRODUCT:
        case Const.TYPE_EQUIPMENT_MODEL_REVISION:
        case Const.TYPE_PLANT_PRODUCT:
        case Const.TYPE_MODEL:
        case Const.TYPE_PRODUCT:
        case Const.TYPE_PROCESS_PRODUCT:
        case Const.TYPE_SYSTEM_PRODUCT:
        case Const.TYPE_PROCESS_MODEL_REVISION:
        case Const.TYPE_SYSTEM_MODEL_REVISION:
        case Const.TYPE_PLANT_PRODUCT_INSTANCE:
        case Const.TYPE_COMPONENT:
        case Const.TYPE_BUILD:
        case Const.TYPE_MODEL_REVISION:
            return 'equipment';

        case Const.TYPE_SERVICE:
        case Const.TYPE_SERVICE_PRODUCT:
        case Const.TYPE_SERVICE_MODEL_REVISION:
            return 'service';

        case Const.TYPE_PLANT:
        case Const.TYPE_PLANTUNIT:
        case Const.TYPE_PLANT:
        case Const.TYPE_MODULE:
        case Const.TYPE_EQUIPMENT:
        case Const.TYPE_COMPONENT:
            return 'plant';

        case Const.SORT_UP:
        case Const.SORT_DOWN:
        case Const.CHEVRON_UP:
        case Const.CHEVRON_DOWN:
        case Const.CHEVRON_RIGHT:
        case Const.CHEVRON_LEFT:
        case Const.CLOSE_SIBLINGS:
        case Const.OPEN_SIBLINGS:
        case Const.CIRCLE:
        case Const.CLOSE:
        case Const.EDIT:
        case Const.INFO:
        case Const.WARNING:
        case Const.MENU:
        case Const.DROPFILES:
        case Const.SEARCH:
        case Const.REMOVE:
        case Const.INFO_ROUNDED:
        case Const.CALENDAR:
            return type;
        default:
            return 'circle';
    }
}
